module.exports = __webpack_public_path__ + "img/a4.3389ace0.png";